import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./input.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./input.component.scss?ngResource";
import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { SharedConstants } from "../../constants/shared.constants";
let InputComponent = class InputComponent {
    placeHolder;
    label;
    parentFormGroup;
    required = false;
    formControlName;
    requiredErrorText;
    value = "";
    inputID = "";
    disabled;
    type = "text";
    /*constructor(
      // Retrieve the dependency only from the local injector,
      // not from parent or ancestors.
      @Self()
      // We want to be able to use the component without a form,
      // so we mark the dependency as optional.
      @Optional()
      private ngControl: NgControl
    ) {
      if (this.ngControl) {
        this.ngControl.valueAccessor = this;
      }
    }*/
    ngOnInit() {
        this.setFormControlName();
        this.addToFormGroup();
        this.defaultPlaceHolder();
        this.requiredErrorText = `${this.label} is required`;
        this.inputID = `${this.label}  ${Math.random()}`;
    }
    hasRequiredError() {
        return false;
    }
    getFormControl() {
        return this.parentFormGroup.get(this.formControlName);
    }
    hasErrors() {
        const formControl = this.getFormControl();
        return formControl.invalid && (formControl.dirty || formControl.touched);
    }
    getFirstErrorAvailable() {
        if (this.getFormControl().errors.required) {
            return `${this.label} is required`;
        }
    }
    addToFormGroup() {
        if (!this.parentFormGroup) {
            this.parentFormGroup = new FormGroup({});
        }
        this.parentFormGroup.addControl(this.formControlName, new FormControl({ value: "", disabled: this.disabled }, this.getValidators()));
    }
    getValidators() {
        const validatorsList = [];
        if (this.required) {
            validatorsList.push(Validators.required);
        }
        return validatorsList;
    }
    setFormControlName() {
        this.formControlName = this.label.toLocaleLowerCase();
    }
    defaultPlaceHolder() {
        if (!this.placeHolder) {
            this.placeHolder = `A value ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`;
        }
    }
    static propDecorators = {
        placeHolder: [{ type: Input }],
        label: [{ type: Input }],
        parentFormGroup: [{ type: Input }],
        required: [{ type: Input }]
    };
};
InputComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-input[label]",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], InputComponent);
export { InputComponent };
